<template>
    <div class='comp-basic-plan'>
        <p class='des'>
            <span class='plan-title'>{{planTitle}}: </span><span v-html="$t( 'basicPlan.planDetailsNew')"></span>&nbsp;
            <a class="ui-link" @click='goSubscription' :class="{disabled: !showSubscribe}">
                <span class="text" v-if="!showSubscribe">{{ $t('subscribe.not_available') }}</span>
                <span class="text" v-else-if="displayOnly && userStatus === 'logined'">{{ $t('subscribe.select_device_to_buy') }}</span>
                <span class="text" v-else-if="displayOnly">{{ $t('subscribe.login_and_select_device') }}</span>
                <span class="text" v-else-if="loc==='homepage'">{{ $t('basicPlan.learnMore') }}</span>
                <span class="text" v-else-if="loc==='subscribe'">{{ $t('basicPlan.subscribeNow') }}</span>
                <span class="text" v-else-if="loc==='update'">{{ $t('basicPlan.switchTo') }}</span>
                <span class="ui-icon icon-icon_arrow-right"></span>
            </a>
        </p>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { getSubscriptions } from '@/api/subscriptions';
import user from '@/api/user';
import { IBasicSeries, ISubscribeArgs } from '../lib/types';

export default Vue.extend({

    data () {

        return {
            locKey: '' as string,
            modelKeyInside: '' as string
        };

    },

    props: {
        type: String,
        planTitle: String,
        loc: String,
        cloudProductLists: Object,
        locationKey: String,
        modelKey: String,
        basicSerial: Object as PropType<IBasicSeries>,
        showSubscribe: {
            type: Boolean,
            default: true
        },
        displayOnly: Boolean
    },

    methods: {
        async goSubscription () {

            if ( !this.showSubscribe ) {

                return;

            }

            if ( this.displayOnly ) {

                await this.$router.push({
                    path: '/user/my-devices/',
                    query: { tab: 'sim' }
                });
                return;

            }

            if ( this.loc === 'subscribe' || this.loc === 'update' ) {

                this.$emit( 'subscribe', {
                    plan: this.basicSerial.plans[0],
                    series: this.basicSerial,
                    availableModels: this.cloudProductLists.deviceModelGroups[this.basicSerial.deviceGroup].models?.map( item => item.text.toLowerCase())
                } as ISubscribeArgs );
                return;

            }
            if ( this.userStatus === 'logined' ) {

                try {

                    let sub = await getSubscriptions( 'active' );
                    let hasBasic = '0';
                    let subId = '0';
                    for ( let item of sub.items ) {

                        let plan;
                        if ( typeof this.cloudProductLists.plans[item.plan] !== 'undefined' ) {

                            item.plan = this.cloudProductLists.plans[item.plan];
                            plan = this.cloudProductLists.plans[item.plan];

                        }

                        if ( typeof plan === 'object' && Number( plan.cycle.salePrice ) === 0 ) {

                            hasBasic = plan.id;
                            subId = item.id;
                            break;

                        }

                    }
                    if ( Number( hasBasic )) {

                        this.$router.push({
                            name: 'update-cloud',
                            query: {
                                ps_id: subId,
                                loc: this.locKey,
                                model: this.modelKeyInside
                            }

                        }).catch( console.error );

                    } else {

                        this.$router.push({
                            name: 'subscribe-cloud',
                            query: {
                                loc: this.locKey,
                                model: this.modelKeyInside
                            }
                        }).catch( console.error );

                    }

                } catch ( err ) {

                    console.log( err );

                }

            } else {

                user.goToAccountCenter( true ).catch( console.error );

            }

        }
    },
    computed: {

        userStatus (): string {

            return this.$store.state.user.status;

        }
    },
    watch: {

        locationKey: {
            handler ( val ) {

                this.locKey = val;

            },
            immediate: true
        },
        modelKey: {
            handler ( val ) {

                this.modelKeyInside = val;

            },
            immediate: true
        }
    }
});
</script>

<style scoped lang="less">
.comp-basic-plan{
    border-radius: @border-radius-level-2;
    text-align: left;
    padding: 20px;
    font-size: 14px !important;
    background-color: @bg_01;
    p{
        margin-bottom: 0;
        font-size: 14px;
    }

    .goBasic{
        cursor: pointer;
        text-decoration: underline;
        text-decoration-thickness:1px;
    }
    .plan-title{
        font-weight: 500;
    }
    .ui-link{
        @media @pc{
            white-space: nowrap;
        }
        span{
            font-size: 14px;

        }
        &.disabled{
            cursor: not-allowed;
            .text{
                color: @font_secondary;
            }
            .ui-icon{
                color: @font_secondary;
            }
        }
    }

}

</style>
